<template>  
  <div>
    <v-layout>
      <v-flex md4 class="px-4">
        <h3>EBITDA de {{year || '...'}}</h3>
			</v-flex>
      <v-flex md5 class="px-4">
        <slot name="mid-header">

        </slot>
			</v-flex>
      <v-flex md3 class="px-4">
        <template v-if="myPermissions.includes(2)">
          <v-btn color="primary" small @click="addItem" class="float-r" :disabled="!year || !(listImpactedAreas.length > filteredRows.length)">
            <v-icon>add</v-icon>
            <span>Agregar EBITDA</span>
          </v-btn>
        </template>
			</v-flex>
    </v-layout>
    <br>
		<v-layout>
			<v-flex md12>
        <v-data-table
			    hide-default-footer
          :headers="headers"
          :items="filteredRows"
          item-key="id"
          class="tablaT1"
          :class="dark_t?'dark':''">
          <template v-slot:item="props">
            <tr>
              <td :style="`background-color:${dark_t?'black':'white'}`">
                <v-icon @click="askForDelete(props.item)" style="color:darkred" v-if="myPermissions.includes(2)">delete</v-icon>
              </td>
              <td>
                <fs1-span>{{impactedAreaName(props.item.impacted_area)}}</fs1-span>
              </td>
              <td>
                <fs1-span>{{props.item.value}}</fs1-span>
              </td>
              <td :style="`background-color:${dark_t?'black':'white'}`">
                <v-icon @click="selectedItem = {...props.item}; dialog = true" v-if="myPermissions.includes(2)">edit</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-icon>warning</v-icon>Sin Información.
          </template>
        </v-data-table>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialog" width="400">
			<v-card class="pa-40 textAlignCenter">
				<h3>{{year}}</h3>
				<div class="mt-40">
          <v-autocomplete
            
            
            :class="!selectedItem.impacted_area && 'textEmpty'"
            placeholder=" Ingrese área impactada"
            v-model="selectedItem.impacted_area"
            :items="listImpactedAreasFiltered(selectedItem.impacted_area)"
            hide-details
            prepend-icon="edit" 
            hide-no-data
            :item-text="(r) => `${r.full_name}(${r.name})`"
            item-value="id"
            hide-selected/>
				</div>
				<div class="mt-40">
          <!-- <in-num v-model="selectedItem.value" placeholder="Valor del EBIT" p_icon="edit"/> -->
          <v-text-field placeholder="Valor del EBIT"
          type="number"
            clearable
            prepend-icon="edit" 
            :class="!selectedItem.value && 'textEmpty'"
            v-model="selectedItem.value"/>
				</div>
				<br>
				<div>
					<v-btn color="secondary" @click="dialog = false">
						<v-icon>close</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="save">
						<v-icon class="mr-1">save</v-icon>
						<span>Guardar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-model="deleteDialog" width="400">
			<v-card class="pa-20 textAlignCenter">
				<h3>{{selectedItem.name}}</h3>
				<h4>¿Seguro desea eliminar el EBIT del "{{selectedItem.fiscal_year}}"?</h4>
				<br>
				<div>
					<v-btn color="secondary" @click="deleteDialog = false">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="deleteItem(selectedItem)">
						<v-icon>delete</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
  </div>	
</template>

<script>
import { addEbits, editEbit } from '@/requests/ac';
import SimpleCrud from '@/components/mixins/simpleCrud/SimpleCrud';
const thisYear = new Date().getFullYear();

export default {
  mixins: [SimpleCrud],
  props: ['year'],
  data() {
    return {
      storeKey: 'ebits',
    };
  },
  computed: {
    listImpactedAreas() { return this.$store.getters.listImpactedAreas },
    ebits() { return this.$store.getters.ebits },
    add() { return addEbits },
    edit() { return editEbit },
    defaultItem() { return JSON.parse(JSON.stringify({value: null, fiscal_year: this.year, impacted_area: null }))},
    filteredRows() { 
      const rows = this.rows.filter(f => f.fiscal_year === this.year);
      return rows;
    },
    years() {
      const ys = [];
      for (let i = 1990; i < (thisYear+10); i++) ys.push(i);
      return ys;
    },
    filterYears() {
      const ret = [];
      const selectedYears = this.filteredRows.map(y => y.fiscal_year);
      if (selectedYears.length === 0) return this.years;

      return this.years.filter(y => !selectedYears.includes(y));
    },
    headers() {
      return [
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
				{ text: 'Área impactada', sortable: true, value: 'impacted_area' },
				{ text: 'Valor', sortable: true, value: 'value' },
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
      ];
    },
  },
  methods: {
    listImpactedAreasFiltered(id){
      return this.listImpactedAreas.filter(f => f.id === id || !this.filteredRows.find(fr => fr.impacted_area === f.id))
    },
    impactedAreaName(id){
      return (this.listImpactedAreas.find(f => f.id === id) || {}).name || ''
    },
    addToAList(item) {
      const imp = this.listImpactedAreas.find(f => f.id === item.impacted_area);
      imp.ebits.push(item);
    },
    removeFromList(item) {
      /* const list = this.ImpactedArea.ebits;
      list.splice(list.indexOf(item), 1); */
    },
  },
};
</script>
